export default "__VITE_ASSET__gWVxw_GV__"